
(function organizationalUnitAssociateProfileControllerDefinition() {
    'use strict';

    angular.module('OrganizationalUnit')
        .controller('OrganizationalUnitAssociateProfileController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', '$q', 'authExtend', 'errorsExtend', 'adminOrganizationalUnitService', 'containerTypeService', 'adminContainerTypeService', 'messages', '$filter',
    function organizationalUnitAssociateProfileController($scope, config, $state, $translate, $stateParams, $q, authExtend, errors, adminOrganizationalUnitService, containerTypeService, adminContainerTypeService, messages, $filter) {

        $scope.load = function () {
            $scope.aux = {
                containerTypes: [],
                genericContainerType: {},
                oldContainerType: undefined
            };

            $scope.data = {
                associations: [],
                genericContainerType: {},
                customContainerType: undefined,
                containerTypes: [],
                organizationalUnitName: '',
                organizationalUnitId: $stateParams.id
            };

            var _legPromise = containerTypeService.getBySystemName("_leg");
            var _customTypesPromise = adminContainerTypeService.getMetadataMappings($scope.data.organizationalUnitId);

            $q.all([_legPromise, _customTypesPromise]).then(function (result) {
                $scope.data.genericContainerType = angular.copy(result[0]);
                $scope.aux.genericContainerType = angular.copy(result[0]);
                $scope.data.containerTypes = angular.copy(result[1]);
                $scope.aux.containerTypes = angular.copy(result[1]);

                if ($scope.data.containerTypes.length > 0) {
                    $scope.data.organizationalUnitName = $scope.data.containerTypes[0].organizationalUnitName;
                    // cargar mapeos existentes
                    $scope.loadMappings();
                } else {
                    errors.showError('Ou_no_containers');
                    $scope.cancel();
                }
            });
        };

        $scope.load();

        $scope.cancel = function () {
            $state.go('organizational-unit-find');
        };

        $scope.save = function () {
            if (!$scope.data.customContainerType) {
                errors.showError("Ou_select_containerType");
                return false;
            }

            if ($filter('filter')($scope.data.genericContainerType.metadata, { isRequired: true }).length > 0) {
                errors.showError("Ou_leg_metadatas");
                return false;
            }

            var associations = {
                containerTypeId: $scope.data.customContainerType.id,
                organizationalUnitId: $scope.data.customContainerType.organizationalUnitId,
                sourceMappings: [],
                targetMappings: []
            }

            $scope.data.associations.forEach(function (item) {
                if (item.sourceAdded && item.targetAdded) {
                    associations.sourceMappings.push(item.sourceMetadata.metadataId);
                    associations.targetMappings.push(item.targetMetadata.metadataId);
                }
            });

            return adminContainerTypeService.setMetadataMappings(associations).then(function (result) {
                $state.go('organizational-unit-find');
            }, function (error) {
                errors.showError(error);
            });
        };

        $scope.addAssociation = function (mapping) {
            if (!mapping.sourceMetadata || !mapping.targetMetadata) {
                errors.showError("Ou_no_metadatas");
                return;
            }

            if (mapping.sourceMetadata.metadataType !== mapping.targetMetadata.metadataType) {
                errors.showError("Ou_type_mismatch");
                return;
            }

            var resultMismatchComboValues = $scope.mismatchComboValues(mapping);
            if (resultMismatchComboValues !==  "") {
                errors.showError({ data: { key: "Ou_values_type_mismatch", value: { data: resultMismatchComboValues }}});
                return;
            }

            mapping.sourceAdded = true;
            mapping.targetAdded = true;

            var sourceIndex = $scope.data.customContainerType.metadata.indexOf(mapping.sourceMetadata);
            var targetIndex = $scope.data.genericContainerType.metadata.indexOf(mapping.targetMetadata);

            $scope.data.customContainerType.metadata.splice(sourceIndex, 1);
            $scope.data.genericContainerType.metadata.splice(targetIndex, 1);

            if ($scope.data.genericContainerType.metadata.length > 0 &&
                $scope.data.customContainerType.metadata.length > 0) {
                $scope.data.associations.push({
                    sourceAdded: false,
                    targetAdded: false
                });
            }
        };

        $scope.mismatchComboValues = function (mapping) {
            var result = "";
            if (mapping.sourceMetadata.optionValues !== null && mapping.targetMetadata.optionValues !== null) {
                var source = angular.fromJson(mapping.sourceMetadata.optionValues);
                var target = angular.fromJson(mapping.targetMetadata.optionValues);

                for (var i = 0; i < target.length; i++) {
                    var foundValue = $filter('filter')(source, { value: target[i].value }, true);
                    if (foundValue == 0) {
                        if (i != target.length - 1) {
                            result = result.concat(target[i].value + ",");
                        }
                        else {
                            result = result.concat(target[i].value);
                        }
                    }
                }
            }

            return result;
        };

        $scope.removeAssociation = function (mapping) {
            if ($scope.data.genericContainerType.metadata.length == 0 ||
                $scope.data.customContainerType.metadata.length == 0) {
                $scope.data.associations.push({
                    sourceAdded: false,
                    targetAdded: false
                });
            }

            mapping.sourceAdded = false;
            mapping.targetAdded = false;

            var index = $scope.data.associations.indexOf(mapping);

            $scope.data.associations.splice(index, 1);

            $scope.data.customContainerType.metadata.push(mapping.sourceMetadata);
            $scope.data.genericContainerType.metadata.push(mapping.targetMetadata);
        };

        $scope.selectContainerType = function (containerType) {
            var assosiation = $scope.data.associations[0];

            if (assosiation && (assosiation.sourceAdded && assosiation.targetAdded)) {
                messages.showConfirm('Ou_existing_mappings').then(function (result) {
                    if (result) {
                        $scope.cleanAssociations();
                    } else {
                        $scope.data.customContainerType = $scope.aux.oldContainerType;
                    }
                });
            } else {
                $scope.data.associations = [{
                    sourceAdded: false,
                    targetAdded: false
                }];
            }
        };

        $scope.loadMappings = function () {
            $scope.data.containerTypes.forEach(function (item) {
                if (item.sourceMetadataMapping.length > 0 && item.targetMetadataMapping.length > 0) {
                    $scope.data.customContainerType = item;

                    for (var i = 0; i < item.sourceMetadataMapping.length; i++) {
                        var sourceMetadata = $filter('filter')(item.metadata, { metadataId: item.sourceMetadataMapping[i].metadataId })[0];
                        var targetMetadata = $filter('filter')($scope.data.genericContainerType.metadata, { metadataId: item.targetMetadataMapping[i].metadataId })[0];

                        $scope.data.associations.push({
                            sourceMetadata: sourceMetadata,
                            sourceAdded: true,
                            targetMetadata: targetMetadata,
                            targetAdded: true
                        });

                        var sourceIndex = $scope.data.customContainerType.metadata.indexOf(sourceMetadata);
                        var targetIndex = $scope.data.genericContainerType.metadata.indexOf(targetMetadata);

                        $scope.data.customContainerType.metadata.splice(sourceIndex, 1);
                        $scope.data.genericContainerType.metadata.splice(targetIndex, 1);
                    }

                    if ($scope.data.genericContainerType.metadata.length > $scope.data.associations.length) {
                        $scope.data.associations.push({
                            sourceAdded: false,
                            targetAdded: false
                        });
                    }
                }
            });
        };

        $scope.cleanAssociations = function () {
            $scope.data.associations = [{
                sourceAdded: false,
                targetAdded: false
            }];

            $scope.data.genericContainerType = angular.copy($scope.aux.genericContainerType);
            $scope.data.containerTypes = angular.copy($scope.aux.containerTypes);
        };

        $scope.$watch("data.customContainerType", function (newValue, oldValue) {
            $scope.aux.oldContainerType = oldValue;
        });
    }
        ]);
})();